import { lazy } from 'react';

export const ConsentPage = lazy(() =>
  import('@/components/ConsentPage').then((m) => ({
    default: m.ConsentPage,
  })),
);

export const CATermsContent = lazy(() =>
  import('@/pages/web/_components/ca-terms').then((m) => ({
    default: m.CATermsContent,
  })),
);

export const SupportTermsContent = lazy(() =>
  import('@/pages/web/_components/support-terms').then((m) => ({
    default: m.SupportTermsContent,
  })),
);

export const TermsOfServiceContent = lazy(() =>
  import('@/pages/web/_components/terms-of-service').then((m) => ({
    default: m.TermsOfServiceContent,
  })),
);

export const TeamsRoutes = lazy(() =>
  import('src/pages/teams/routes').then((m) => ({
    default: m.TeamsRoutes,
  })),
);

export const ZoomRoutes = lazy(() =>
  import('src/pages/zoom/routes').then((m) => ({
    default: m.ZoomRoutes,
  })),
);

export const WebexRoutes = lazy(() =>
  import('src/pages/webex/routes').then((m) => ({
    default: m.WebexRoutes,
  })),
);

export const MeetRoutes = lazy(() =>
  import('./pages/meet/MeetRoutes').then((m) => ({
    default: m.MeetRoutes,
  })),
);

export const WebAppRoutes = lazy(() =>
  import('./pages/web/_config/_routes/common').then((m) => ({
    default: m.WebAppRoutes,
  })),
);

export const AuthenticationHandlerView = lazy(
  () =>
    import('src/pages/teams/_components/AuthenticationHandlerView/AuthenticationHandlerView'),
);
